import { useState, useEffect } from "react";

import { buscarEmpreendimentosComCidadeService } from "../../../services/buscarEmpreendimentosComCidadeService";
// --------------------- Import Services ---------------------
export const useEmpreendimento = () => {
  const [empreendimento, setEmpreendimento] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  // UseEffect necessário para buscar as empreendimento
  useEffect(() => {
    const fetch = async () => {
      setIsLoading(true);
      try {
        const data = await buscarEmpreendimentosComCidadeService();

      
        
        if (data) {
           const opcoes = await data.map((e: any) => 
            
            ({
           
              label: e.nome,     // o nome visível
              value: e.id,        // ID como valor único
            }
          )
          
        );
           
            setEmpreendimento(opcoes);
          //});
          
        } else {
          console.error("Dados não encontrados");
        }
      } catch (error) {
        console.error("Erro ao buscar empreendimento:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetch();
  }, []);

  return { empreendimento, isLoading };
};
